// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue-300: #5f89f8;
  --blue-400: #395dfb;
  --blue-500: #273cd5;
  --blue-900: #17163d;
  --grey-100: #f5f5f5;
  --grey-200: #e0e0e0;
  --grey-300: #cccccc;
  --grey-400: #b7b7b7;
  --grey-500: #8f8f8f;
  --grey-600: #666666;
  --grey-700: #363636;
  --grey-800: #363636;
  --grey-900: #252525;
  --black-rgba: rgba(0, 0, 0, 0.8);
  --fw-regular: 400;
  --fw-semibold: 600;
  --fw-bold: 700;
  --fs-5xl: 3.5rem;
  --fs-4xl: 3rem;
  --fs-3xl: 2rem;
  --fs-2xl: 1.5rem;
  --fs-xl: 1.25rem;
  --fs-lg: 1.125rem;
  --fs-md: 1rem;
  --fs-sm: 0.875rem;
  --fs-xs: 0.75rem;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
}

@media (max-width: 980px) {
  html {
    font-size: 93.75%;
  }
}
@media (max-width: 720px) {
  html {
    font-size: 87.5%;
  }
}

body {
  color: var(--grey-900);
  background: var(--blue-900);
  -webkit-font-smoothing: antialiased;
}

body,
input,
textarea,
button {
  font-family: "Inter", sans-serif;
  font-weight: var(--fw-regular);
}

h1,
h2,
h3,
h3,
h4,
h5,
h6,
strong {
  font-weight: 700;
}

a {
  color: inherit;
  text-decoration: none;
  transition: ease-in 0.2s;
}
a:hover {
  transition: ease-out 0.3s;
}

button {
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  white-space: nowrap;
}

[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.app {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: var(--blue-900);
  height: 100%;
  width: 100%;
  position: relative;
}
.app .header-bf {
  position: sticky;
  top: 0;
  z-index: 99;
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%), #222034;
  box-shadow: 0px 1px 4px 0px rgba(255, 213, 0, 0.5);
  display: flex;
  justify-content: center;
  padding: 16px 20px;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
.app .header-bf > p {
  text-transform: uppercase;
  color: #fff;
  white-space: nowrap;
  font-weight: bold;
  background: var(--Style, linear-gradient(180deg, #ffd500 0%, #c27a08 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.app .black-november {
  display: flex;
  align-items: center;
  align-self: center;
  padding: 6px 24px;
  justify-content: center;
  gap: 12px;
  border-radius: 40px;
  border: 1px solid #ffd500;
  background: #000;
}
.app .black-november > p {
  font-weight: bold;
  background: var(--Style, linear-gradient(180deg, #ffd500 0%, #c27a08 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
}
.app > header.topbar {
  position: sticky;
  top: 0;
  z-index: 30;
  background-color: var(--blue-900);
  color: white;
  width: 100%;
  max-width: none;
  display: flex;
  justify-content: center;
  padding: 0;
}
.app > header.topbar .topbar-inner {
  width: 100%;
  max-width: 1224px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  gap: 24px;
}
.app > header.topbar .header-nav {
  display: flex;
  align-items: center;
  gap: 28px;
}
.app > header.topbar .header-nav a {
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: rgba(255, 255, 255, 0.86);
}
.app > header.topbar .header-nav a:hover {
  color: white;
}
@media (max-width: 380px) {
  .app > header.topbar a img {
    max-width: 200px;
  }
}
.app > header.topbar .menu {
  display: none;
  background: transparent;
  border: 0;
  padding: 0;
}
.app > header.topbar .header-nav-mobile {
  display: none;
}
.app > header.topbar .dropdown {
  position: relative;
}
.app > header.topbar .header-buttons {
  display: flex;
  align-items: center;
  gap: 40px;
}
.app > header.topbar .header-buttons a {
  font-weight: var(--fw-bold);
  display: flex;
  align-items: center;
  gap: 10px;
}
.app > header.topbar .header-buttons .ghost-link:hover {
  color: var(--blue-300);
  text-decoration: underline;
}
.app > header.topbar .header-buttons .button-link {
  background-color: var(--blue-900);
  padding: 12px 24px;
  border-radius: 6px;
  border: 1px solid rgba(95, 137, 248, 0.4);
  color: var(--blue-300);
  white-space: nowrap;
}
.app > header.topbar .header-buttons .button-link:hover {
  color: white;
  background-color: rgba(95, 137, 248, 0.4);
}
@media (max-width: 980px) {
  .app > header.topbar .header-nav {
    display: none;
  }
}
@media (max-width: 580px) {
  .app > header.topbar .menu {
    display: inline;
    cursor: pointer;
    z-index: 10;
    position: relative;
  }
  .app > header.topbar .header-buttons {
    display: none;
  }
  .app > header.topbar .dropdown.is-open .header-buttons,
  .app > header.topbar .dropdown:hover .header-buttons {
    z-index: 40;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    position: absolute;
    top: calc(100% + 12px);
    right: 0;
    width: calc(100vw - 36px);
    min-width: 0;
    padding: 16px 20px;
    background: #221f4e;
    border: 1px solid rgba(95, 137, 248, 0.55);
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
  }
  .app > header.topbar .header-nav-mobile {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding-bottom: 8px;
  }
  .app > header.topbar .header-nav-mobile a {
    font-weight: var(--fw-semibold);
  }
}
.app .sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 80px;
  color: white;
  width: 100%;
  max-width: 1224px;
  padding: 12px 10px 104px 10px;
}
.app .sub-header .first {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  max-width: 592px;
}
.app .sub-header .first .kicker {
  color: var(--blue-300);
  font-size: var(--fs-xs);
  font-weight: var(--fw-bold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.app .sub-header .first .title {
  font-size: var(--fs-5xl);
  font-weight: var(--fw-bold);
  line-height: 1.15;
  letter-spacing: -0.02em;
}
.app .sub-header .first .text-link {
  color: rgba(255, 255, 255, 0.86);
  font-weight: var(--fw-semibold);
  text-decoration: underline;
  text-underline-offset: 4px;
}
.app .sub-header .first .text-link:hover {
  color: white;
}
.app .sub-header .first .subtitle {
  width: 100%;
  max-width: 488px;
  font-size: var(--fs-xl);
  font-weight: var(--fw-regular);
  line-height: 150%;
}
.app .sub-header .first a {
  margin-top: 24px;
}
.app .sub-header .second {
  max-width: 544px;
}
.app .sub-header .second img {
  width: 100%;
  max-width: 544px;
  height: auto;
}
@media (max-width: 1024px) {
  .app .sub-header {
    flex-direction: column;
    align-items: center;
  }
  .app .sub-header .first {
    align-items: center;
    font-size: var(--fs-3xl);
  }
  .app .sub-header .first p {
    text-align: center;
  }
}
@media (max-width: 580px) {
  .app .sub-header .first {
    align-items: center;
  }
}
.app main {
  width: 100%;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 120px 0;
  align-items: center;
}
.app main .video-box {
  width: 100%;
  max-width: 920px;
  overflow: hidden;
  position: relative;
  margin-bottom: 60px;
  padding: 10px;
}
.app main .video-box iframe {
  border: none;
  width: 100%;
  aspect-ratio: 16/9;
  border-radius: 6px;
  box-shadow: none;
}
.app main .title {
  font-size: var(--fs-4xl);
  font-weight: var(--fw-bold);
  color: var(--grey-900);
  text-align: center;
}
.app main .subtitle {
  font-size: var(--fs-xl);
  font-weight: var(--fw-regular);
  text-align: center;
}
.app main .subtitle strong {
  font-weight: var(--fw-bold);
  text-decoration: underline;
}
.app main .section-header {
  flex-direction: column;
  display: flex;
  gap: 16px;
  align-items: center;
}
.app main .steps {
  display: flex;
  gap: 40px;
  align-items: flex-start;
  margin-top: 58px;
  justify-content: space-between;
}
.app main .steps img {
  margin-top: 40px;
  width: 100%;
  max-width: 160px;
}
.app main .steps .card-step {
  color: var(--grey-800);
  font-size: var(--fs-md);
  gap: 21px;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 176px;
  text-align: center;
  line-height: 150%;
}
.app main .steps .card-step .step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  color: var(--blue-300);
  background-color: rgba(57, 93, 251, 0.1);
  font-size: var(--fs-2xl);
  font-weight: var(--fw-semibold);
}
.app main .leads,
.app main .dream,
.app main .feature-split {
  max-width: 1224px;
  padding: 0 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
.app main .leads img,
.app main .dream img,
.app main .feature-split img {
  width: 100%;
  max-width: 696px;
  height: auto;
}
.app main .leads article,
.app main .dream article,
.app main .feature-split article {
  width: 100%;
  max-width: 384px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.app main .leads article h1,
.app main .leads article h2,
.app main .dream article h1,
.app main .dream article h2,
.app main .feature-split article h1,
.app main .feature-split article h2 {
  font-size: var(--fs-2xl);
  margin-top: 8px;
  line-height: 150%;
}
.app main .leads article p,
.app main .dream article p,
.app main .feature-split article p {
  color: var(--grey-500);
  line-height: 150%;
}
.app main .leads article img,
.app main .dream article img,
.app main .feature-split article img {
  width: 40px;
  height: 40px;
}
.app main .dashboard {
  width: 100%;
  max-width: 1118px;
  margin-top: 120px;
}
.app main .plans-features .video-box {
  max-width: none;
  margin: 4px 0 0;
  padding: 0;
}
.app main .end-section {
  width: 100%;
  border-top: 1px solid #e7eaed;
  padding-top: 80px;
  padding-bottom: 120px;
  display: flex;
  flex-direction: column;
  gap: 120px;
  align-items: center;
}
.app main .end-section .title-animation {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  gap: 56px;
  text-align: center;
}
.app main .end-section .title-animation span {
  animation: marquee 40s linear infinite;
  font-weight: var(--fw-bold);
  font-size: var(--fs-5xl);
  background: linear-gradient(87.07deg, #273cd5 0%, #9bb7ff 100%);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.app main .end-section article {
  position: relative;
  width: 100%;
  max-width: 1216px;
}
.app main .end-section article .container {
  color: white;
  background-color: var(--blue-900);
  display: flex;
  gap: 40px;
  border-radius: 24px;
  justify-content: space-between;
  padding-right: 80px;
  align-items: center;
}
.app main .end-section article .container img {
  margin-top: -46px;
}
.app main .end-section article .container div {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: flex-start;
  max-width: 480px;
  width: 100%;
  padding-top: 45px;
  padding-bottom: 45px;
  padding-left: 80px;
}
.app main .end-section article .container div header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
.app main .end-section article .container div header h1 {
  font-size: var(--fs-3xl);
}
.app main .end-section article .container div header p {
  font-size: var(--fs-xl);
  line-height: 150%;
}
.app main .faq {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 136px;
  width: 100%;
  max-width: 1224px;
  padding: 0 20px;
}
.app main .faq article {
  width: 100%;
  max-width: 280px;
  gap: 16px;
  display: flex;
  flex-direction: column;
}
.app main .faq article h1 {
  font-size: var(--fs-3xl);
  line-height: 48px;
}
.app main .faq article p {
  color: #4d586a;
  line-height: 24px;
}
.app main .faq .accordion {
  width: 100%;
  overflow: hidden;
}
.app main .faq .accordion .accordion-header {
  cursor: pointer;
  padding: 1em;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  transition: background-color 0.2s ease;
  font-size: var(--fs-lg);
  font-weight: var(--fw-semibold);
  padding: 32px 0;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}
.app main .faq .accordion .accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}
.app main .faq .accordion .accordion-header span {
  color: var(--blue-400);
  font-size: var(--fs-3xl);
  font-weight: var(--fw-regular);
}
.app main .faq .accordion .accordion-header.active {
  background-color: white;
}
.app main .faq .accordion .accordion-header:hover {
  background-color: white;
}
.app main .faq .accordion .accordion-content {
  color: var(--grey-500);
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  border-bottom: 1px solid #e7eaed;
}
.app main .faq .accordion .accordion-content:last-of-type {
  border: 0;
}
.app main .faq .accordion .accordion-content.active {
  height: auto;
  max-height: 28em;
  overflow-y: auto;
}
.app main .faq .accordion .accordion-content p {
  padding-bottom: 20px;
}
.app main .plans {
  width: 100%;
  max-width: 1224px;
  padding: 40px 20px 80px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 28px;
}
.app main .plans .plans-intro {
  max-width: 640px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.app main .plans .plans-intro h2 {
  font-size: var(--fs-4xl);
  line-height: 1.15;
  letter-spacing: -0.02em;
}
.app main .plans .plans-intro p {
  color: var(--grey-600);
  font-size: var(--fs-lg);
  line-height: 1.5;
}
.app main .plans .plans-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 380px;
  gap: 32px 28px;
  align-items: start;
}
@media (max-width: 980px) {
  .app main .plans .plans-layout {
    grid-template-columns: 1fr;
  }
  .app main .plans .plans-features ul {
    grid-template-columns: 1fr;
  }
  .app main .plans .plans-intro h2 {
    font-size: var(--fs-3xl);
  }
}
.app main .plans .plans-features {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.app main .plans .plans-features h3 {
  font-size: var(--fs-2xl);
  line-height: 1.3;
}
.app main .plans .plans-features ul {
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.app main .plans .plans-features li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 16px;
  background: white;
}
.app main .plans .plans-features li > span {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--blue-400);
  background: rgba(57, 93, 251, 0.1);
}
.app main .plans .plans-features li strong {
  display: block;
  font-size: var(--fs-sm);
  line-height: 1.4;
}
.app main .plans .plans-features li p {
  margin-top: 4px;
  color: var(--grey-600);
  font-size: var(--fs-xs);
  line-height: 1.5;
}
.app main .plans .plans-cards {
  display: flex;
  width: 100%;
}
.app main .plans .plans-cards article {
  width: 100%;
  min-width: 0;
  max-width: none;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  padding: 40px 32px;
  justify-content: space-between;
  gap: 28px;
}
.app main .plans .plans-cards article h1 {
  display: flex;
}
.app main .plans .plans-cards article.recomended {
  border: 2px solid var(--blue-300);
  transform: scale(1.05);
}
.app main .plans .plans-cards article.recomended .black-november {
  display: none;
}
.app main .plans .plans-cards article.recomended h1 {
  align-items: center;
  gap: 12px;
}
.app main .plans .plans-cards article.recomended h1 span {
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  font-size: 10px;
  background-color: var(--blue-500);
}
.app main .plans .plans-cards article.recomended-bf {
  background-color: #000;
  border: 2px solid rgb(255, 196, 0);
  transform: scale(1.05);
}
.app main .plans .plans-cards article.recomended-bf article,
.app main .plans .plans-cards article.recomended-bf header {
  background-color: #000;
}
.app main .plans .plans-cards article.recomended-bf article h1,
.app main .plans .plans-cards article.recomended-bf article p,
.app main .plans .plans-cards article.recomended-bf header h1,
.app main .plans .plans-cards article.recomended-bf header p {
  color: #fff !important;
}
.app main .plans .plans-cards article.recomended-bf h1 {
  align-items: center;
  gap: 12px;
}
.app main .plans .plans-cards article.recomended-bf h1 span {
  padding: 6px 12px;
  border-radius: 20px;
  color: white;
  font-size: 10px;
  background-color: rgb(255, 196, 0);
}
.app main .plans .plans-cards article.recomended-bf a {
  background-color: rgb(255, 196, 0);
  color: #252525;
  border-color: #252525;
  font-weight: var(--fw-bold);
  text-transform: uppercase;
  font-size: var(--fs-sm);
  line-height: 150%;
}
.app main .plans .plans-cards article header {
  display: flex;
  flex-direction: column;
  background-color: white;
  gap: 16px;
  align-items: flex-start;
}
.app main .plans .plans-cards article header h1 {
  color: var(--blue-400);
  font-size: var(--fs-sm);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 100%;
}
.app main .plans .plans-cards article header > p {
  max-width: 280px;
  color: var(--grey-500);
  font-size: var(--fs-sm);
  line-height: 150%;
}
.app main .plans .plans-cards article header > p span {
  background-color: #08b15c;
  color: #f5f5f5;
  font-size: var(--fs-xs);
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: var(--fw-bold);
}
.app main .plans .plans-cards article header > p strong {
  color: var(--grey-300);
}
.app main .plans .plans-cards article header > div {
  display: flex;
  gap: 12px;
  flex-direction: column;
}
.app main .plans .plans-cards article header > div .price {
  font-size: 40px;
  color: var(--grey-900);
  font-weight: var(--fw-bold);
}
.app main .plans .plans-cards article header > div .price small {
  font-size: var(--fs-xs);
  color: var(--grey-400);
}
.app main .plans .plans-cards article header > div p {
  color: var(--grey-400);
}
.app main .plans .plans-cards article header .items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.app main .plans .plans-cards article header .items div {
  display: flex;
  align-items: center;
  gap: 12px;
}
.app main .plans .plans-cards article header .items div img {
  width: 11px;
  height: auto;
}
.app main .plans .plans-cards article header .items div p {
  color: var(--grey-500);
  font-size: var(--fs-sm);
}
.app main .plans .plans-cards article header .items div p span {
  background-color: var(--blue-900);
  color: #f5f5f5;
  font-size: var(--fs-xs);
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: var(--fw-bold);
}
@media (max-width: 820px) {
  .app main .plans .plans-cards article {
    min-width: 100%;
  }
  .app main .plans .plans-cards article header p {
    max-width: 100%;
  }
}
.app main .plans .plans-cards article .divider {
  background-color: var(--grey-200);
  height: 1px;
  margin: 12px 0;
}
.app main .block {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}
.app main .feature-wide {
  width: calc(100% - 20px);
  max-width: 920px;
  height: auto;
  border-radius: 24px;
}
.app main .feature-split > img {
  border-radius: 16px;
}
.app main .feature-split article {
  max-width: 480px;
}
.app main .feature-split .chips {
  justify-content: flex-start;
}
.app main .feature-split .feature-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.app main .feature-split .feature-list li {
  position: relative;
  padding-left: 16px;
  color: var(--grey-600);
  line-height: 1.55;
  font-size: var(--fs-sm);
}
.app main .feature-split .feature-list li::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--blue-400);
  position: absolute;
  left: 0;
  top: 0.55em;
}
.app main .product {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 120px;
}
.app main .section-intro {
  width: 100%;
  max-width: 760px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}
.app main .section-intro h2 {
  font-size: var(--fs-3xl);
  line-height: 1.25;
  letter-spacing: -0.02em;
}
.app main .section-intro p {
  color: var(--grey-600);
  line-height: 1.6;
  font-size: var(--fs-lg);
}
.app main .kicker {
  color: var(--blue-400);
  font-size: var(--fs-xs);
  font-weight: var(--fw-bold);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.app main .tag {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--blue-900);
  color: #f5f5f5;
  font-size: 11px;
  font-weight: var(--fw-bold);
  letter-spacing: 0;
  vertical-align: middle;
}
.app main .chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}
.app main .chips span {
  border: 1px solid #e0e0e0;
  background: #f7f8fc;
  color: var(--grey-700);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: var(--fs-sm);
  line-height: 1.4;
}
.app main .card-grid {
  width: 100%;
  max-width: 1224px;
  padding: 0 10px;
  display: grid;
  gap: 24px;
  margin-top: 8px;
}
.app main .card-grid.two {
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}
.app main .card-grid.three {
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}
.app main .info-card {
  border: 1px solid #e0e0e0;
  border-radius: 24px;
  overflow: hidden;
  background: white;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.app main .info-card img {
  width: 100%;
  height: auto;
  display: block;
  background: #f4f6fb;
}
.app main .info-card .info-body {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}
.app main .info-card .info-body h3 {
  font-size: var(--fs-2xl);
  line-height: 1.3;
}
.app main .info-card .info-body p,
.app main .info-card .info-body li {
  color: var(--grey-600);
  line-height: 1.6;
}
.app main .info-card .info-body ul {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}
.app main .info-card .info-body li {
  position: relative;
  padding-left: 16px;
  font-size: var(--fs-sm);
}
.app main .info-card .info-body li::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--blue-400);
  position: absolute;
  left: 0;
  top: 0.55em;
}
.app main #modos,
.app main #temas,
.app main #editor,
.app main #arquivos,
.app main #plans,
.app main #faq {
  scroll-margin-top: 96px;
}
@media (max-width: 980px) {
  .app main .leads img,
  .app main .dream img,
  .app main .feature-split img {
    max-width: 520px;
  }
  .app main .end-section {
    gap: 80px;
  }
  .app main .end-section article {
    padding: 0 20px;
  }
  .app main .end-section article .container {
    overflow: hidden;
    padding-right: 0;
    flex-direction: column;
  }
  .app main .end-section article .container img {
    margin-top: 0;
  }
  .app main .end-section article .container div {
    max-width: 100%;
  }
  .app main .faq {
    gap: 40px;
  }
}
@media (max-width: 580px) {
  .app main {
    padding: 64px 0;
  }
  .app main .product {
    gap: 72px;
  }
  .app main .title {
    font-size: 24px;
  }
  .app main .leads,
  .app main .dream,
  .app main .feature-split {
    padding: 0 20px;
  }
  .app main .end-section article .container {
    border-radius: 0;
  }
  .app main .end-section article .container div a {
    width: 100%;
  }
  .app main .plans h1 {
    font-size: var(--fs-3xl);
  }
}
@media (max-width: 780px) {
  .app main .dream,
  .app main .feature-split {
    flex-direction: column;
    gap: 60px;
  }
  .app main .leads,
  .app main .feature-split.media-first {
    flex-direction: column-reverse;
    gap: 60px;
  }
  .app main .steps {
    flex-direction: column;
    gap: 60px;
  }
  .app main .steps img:first-of-type {
    margin-top: 60px;
    margin-bottom: 60px;
    margin-left: 10px;
    transform: rotate(90deg);
  }
  .app main .end-section article {
    padding: 0;
  }
  .app main .end-section article .container div {
    text-align: center;
    padding: 60px 20px;
    align-items: center;
  }
  .app main .end-section article .container div header {
    align-items: center;
  }
  .app main .end-section article .container div header p {
    max-width: 420px;
  }
  .app main .faq {
    flex-direction: column;
  }
  .app main .faq article {
    text-align: center;
    justify-content: center;
    max-width: 100%;
    align-items: center;
  }
  .app main .faq article p {
    max-width: 380px;
  }
}
.app footer {
  width: 100%;
  background-color: var(--blue-900);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.app footer .footer-line {
  height: 1px;
  width: 100%;
  background: linear-gradient(90deg, var(--blue-900), rgba(95, 137, 248, 0.7), var(--blue-900));
}
.app footer .footer-main {
  width: 100%;
  max-width: 1224px;
  padding: 56px 20px 40px;
  display: grid;
  grid-template-columns: 1.3fr repeat(4, 1fr);
  gap: 32px 24px;
}
.app footer .footer-brand {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
.app footer .footer-brand img {
  width: 180px;
  height: auto;
}
.app footer .footer-brand p {
  color: rgba(255, 255, 255, 0.62);
  font-size: var(--fs-sm);
  line-height: 1.6;
  max-width: 260px;
}
.app footer .footer-address {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.app footer .footer-address span {
  color: rgba(255, 255, 255, 0.42);
  font-size: var(--fs-xs);
  line-height: 1.5;
}
.app footer nav {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}
.app footer nav h2 {
  color: white;
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  margin-bottom: 6px;
}
.app footer nav a {
  color: rgba(255, 255, 255, 0.62);
  font-size: var(--fs-sm);
  line-height: 1.45;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.app footer nav a:hover {
  color: white;
}
.app footer .footer-bar {
  width: 100%;
  max-width: 1224px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px 24px;
  flex-wrap: wrap;
}
.app footer .footer-bar p,
.app footer .footer-bar a,
.app footer .footer-bar span {
  color: rgba(255, 255, 255, 0.42);
  font-size: var(--fs-xs);
}
.app footer .footer-bar a:hover {
  color: rgba(255, 255, 255, 0.8);
}
.app footer .footer-bar div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px 12px;
}
@media (max-width: 1100px) {
  .app footer .footer-main {
    grid-template-columns: 1fr 1fr;
  }
  .app footer .footer-brand {
    grid-column: 1/-1;
  }
}
@media (max-width: 640px) {
  .app footer .footer-main {
    grid-template-columns: 1fr;
  }
  .app footer .footer-bar {
    flex-direction: column;
    align-items: flex-start;
  }
}

.terms {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.modal-loading {
  width: 100%;
  max-width: 400px;
  padding: 40px 30px;
  color: var(--grey-600);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-register {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 32px;
}
.form-register h1 {
  font-size: var(--fs-lg);
  color: var(--grey-700);
  font-weight: var(--fw-regular);
  line-height: 150%;
}
.form-register input {
  padding: 12px 12px;
  border: 2px solid var(--blue-300);
  border-radius: 4px;
  font-size: var(--fs-md);
  color: var(--blue-900);
}
.form-register input::placeholder {
  color: var(--grey-400);
}

.divider {
  border-bottom: 1px solid #e7eaed;
  margin: 120px 0;
  width: 100%;
  max-width: 1224px;
}

.btn {
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  white-space: nowrap;
  border-radius: 6px;
  font-weight: var(--fw-bold);
}

.btn-primary {
  border: 1px solid var(--blue-400);
  background-color: var(--blue-400);
  color: white;
}
.btn-primary:hover {
  border: 1px solid var(--blue-300);
  background-color: var(--blue-300);
}

.btn-size-lg {
  padding: 16px 32px;
  font-size: var(--fs-lg);
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.fullscreen-menu .ReactModal__Overlay {
  transform: translateX(-100%);
}

.react-modal-overlay {
  background: var(--black-rgba);
  backdrop-filter: blur(5px);
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-modal-content {
  background-color: var(--grey-100);
  padding: 32px 32px;
  position: absolute;
  border-radius: 5px;
  inset: 40px;
  overflow-y: auto;
}
.react-modal-content h2 {
  padding-right: 52px;
  color: var(--blue-400);
}
.react-modal-content ::-webkit-scrollbar {
  border-radius: 10px;
  background-color: var(--blue-300);
  width: 10px;
}
.react-modal-content ::-webkit-scrollbar-track {
  background-color: transparent;
}
.react-modal-content ::-webkit-scrollbar-thumb {
  background-color: var(--grey-100);
  border-radius: 10px;
}
@media (max-width: 480px) {
  .react-modal-content {
    padding: 30px 20px;
  }
}

.react-modal-close {
  position: absolute;
  right: 5px;
  top: 12px;
  border: 0;
  background: transparent;
  font-size: 2rem;
  color: var(--blue-300);
  transition: ease-in 0.2s;
}
.react-modal-close:hover {
  transition: ease-out 0.4s;
  color: var(--blue-900);
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AAEA;EAEE,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,gCAAA;EAEA,iBAAA;EACA,kBAAA;EACA,cAAA;EAEA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AANF;;AASA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;AANF;;AASE;EADF;IAEI,iBAAA;EALF;AACF;AAME;EAJF;IAKI,gBAAA;EAHF;AACF;;AAQA;EACE,sBAAA;EACA,2BAAA;EACA,mCAAA;AALF;;AAOA;;;;EAIE,gCAAA;EACA,8BAAA;AAJF;;AAMA;;;;;;;;EAQE,gBAAA;AAHF;;AAKA;EACE,cAAA;EACA,qBAAA;EACA,wBAAA;AAFF;AAGE;EACE,yBAAA;AADJ;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAGA;EACE,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;AAEE;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,0FAAA;EAMA,kDAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AALJ;AAMI;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,2EAAA;EAIA,qBAAA;EACA,6BAAA;EACA,oCAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AATJ;AAUI;EACE,iBAAA;EACA,2EAAA;EAIA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,yBAAA;AAXN;AAeE;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;AAbJ;AAeI;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAbN;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAdN;AAgBM;EACE,uBAAA;EACA,+BAAA;EACA,gCAAA;AAdR;AAgBQ;EACE,YAAA;AAdV;AAmBI;EAEI;IACE,gBAAA;EAlBR;AACF;AAsBI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AApBN;AAuBI;EACE,aAAA;AArBN;AAwBI;EACE,kBAAA;AAtBN;AAyBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAvBN;AAyBM;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAvBR;AA0BQ;EACE,sBAAA;EACA,0BAAA;AAxBV;AA4BM;EACE,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,sBAAA;EACA,mBAAA;AA1BR;AA4BQ;EACE,YAAA;EACA,yCAAA;AA1BV;AA+BI;EACE;IACE,aAAA;EA7BN;AACF;AAgCI;EACE;IACE,eAAA;IACA,eAAA;IACA,WAAA;IACA,kBAAA;EA9BN;EAiCI;IACE,aAAA;EA/BN;EAkCI;;IAEE,WAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;IACA,sBAAA;IACA,QAAA;IACA,yBAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,0CAAA;IACA,mBAAA;IACA,2CAAA;EAhCN;EAmCI;IACE,aAAA;IACA,sBAAA;IACA,SAAA;IACA,mBAAA;EAjCN;EAmCM;IACE,+BAAA;EAjCR;AACF;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,6BAAA;AApCJ;AAsCI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AApCN;AAqCM;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;AAnCR;AAqCM;EACE,wBAAA;EACA,2BAAA;EACA,iBAAA;EACA,uBAAA;AAnCR;AAqCM;EACE,gCAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;AAnCR;AAqCQ;EACE,YAAA;AAnCV;AAsCM;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,8BAAA;EACA,iBAAA;AApCR;AAsCM;EACE,gBAAA;AApCR;AAwCI;EACE,gBAAA;AAtCN;AAwCM;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAtCR;AA0CI;EA7DF;IA8DI,sBAAA;IACA,mBAAA;EAvCJ;EAyCI;IACE,mBAAA;IACA,wBAAA;EAvCN;EAwCM;IACE,kBAAA;EAtCR;AACF;AA0CI;EACE;IACE,mBAAA;EAxCN;AACF;AA4CE;EACE,WAAA;EAEA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AA3CJ;AA6CI;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AA3CN;AA6CM;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA3CR;AA+CI;EACE,wBAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;AA7CN;AAgDI;EACE,uBAAA;EACA,8BAAA;EACA,kBAAA;AA9CN;AA+CM;EACE,2BAAA;EACA,0BAAA;AA7CR;AAiDI;EACE,sBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AA/CN;AAkDI;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,8BAAA;AAhDN;AAkDM;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAhDR;AAmDM;EACE,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAjDR;AAmDQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,wCAAA;EACA,wBAAA;EACA,+BAAA;AAjDV;AAsDI;;;EAGE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AApDN;AAsDM;;;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAlDR;AAqDQ;;;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAjDR;AAmDQ;;;;;;EAEE,wBAAA;EACA,eAAA;EACA,iBAAA;AA7CV;AA+CQ;;;EACE,sBAAA;EACA,iBAAA;AA3CV;AA8CQ;;;EACE,WAAA;EACA,YAAA;AA1CV;AA+CI;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AA7CN;AAgDI;EACE,eAAA;EACA,eAAA;EACA,UAAA;AA9CN;AAiDI;EACE,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AA/CN;AAiDM;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AA/CR;AAiDQ;EACE,sCAAA;EACA,2BAAA;EACA,wBAAA;EACA,+DAAA;EACA,qBAAA;EACA,oCAAA;AA/CV;AAmDM;EACE;IACE,yBAAA;EAjDR;EAmDM;IACE,4BAAA;EAjDR;AACF;AAoDM;EACE,kBAAA;EAEA,WAAA;EACA,iBAAA;AAnDR;AAqDQ;EACE,YAAA;EACA,iCAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAnDV;AAqDU;EACE,iBAAA;AAnDZ;AAsDU;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AApDZ;AAsDY;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AApDd;AAsDc;EACE,wBAAA;AApDhB;AAsDc;EACE,uBAAA;EACA,iBAAA;AApDhB;AA4DI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AA1DN;AA4DM;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AA1DR;AA2DQ;EACE,wBAAA;EACA,iBAAA;AAzDV;AA2DQ;EACE,cAAA;EACA,iBAAA;AAzDV;AA6DM;EACE,WAAA;EACA,gBAAA;AA3DR;AA6DQ;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sCAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;AA3DV;AA8DQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AA5DV;AA8DU;EACE,sBAAA;EACA,wBAAA;EACA,8BAAA;AA5DZ;AAgEQ;EACE,uBAAA;AA9DV;AAiEQ;EACE,uBAAA;AA/DV;AAkEQ;EACE,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,oCAAA;EACA,gCAAA;AAhEV;AAkEU;EACE,SAAA;AAhEZ;AAoEQ;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAlEV;AAqEQ;EACE,oBAAA;AAnEV;AAwEI;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AAtEN;AAwEM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AAtER;AAwEQ;EACE,wBAAA;EACA,iBAAA;EACA,uBAAA;AAtEV;AAyEQ;EACE,sBAAA;EACA,uBAAA;EACA,gBAAA;AAvEV;AA2EM;EACE,aAAA;EACA,2CAAA;EACA,cAAA;EACA,kBAAA;AAzER;AA4EM;EACE;IACE,0BAAA;EA1ER;EA6EM;IACE,0BAAA;EA3ER;EA8EM;IACE,wBAAA;EA5ER;AACF;AA+EM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7ER;AA+EQ;EACE,wBAAA;EACA,gBAAA;AA7EV;AAgFQ;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AA9EV;AAiFQ;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AA/EV;AAiFU;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,kCAAA;AA/EZ;AAkFU;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;AAhFZ;AAmFU;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAjFZ;AAsFM;EACE,aAAA;EACA,WAAA;AApFR;AAsFQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,SAAA;AApFV;AAsFU;EACE,aAAA;AApFZ;AAuFU;EACE,iCAAA;EACA,sBAAA;AArFZ;AAuFY;EACE,aAAA;AArFd;AAwFY;EACE,mBAAA;EACA,SAAA;AAtFd;AAuFc;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AArFhB;AA0FU;EACE,sBAAA;EACA,kCAAA;EACA,sBAAA;AAxFZ;AA0FY;;EAEE,sBAAA;AAxFd;AA0Fc;;;;EAEE,sBAAA;AAtFhB;AA0FY;EACE,mBAAA;EACA,SAAA;AAxFd;AAyFc;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AAvFhB;AA2FY;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,iBAAA;AAzFd;AA6FU;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;AA3FZ;AA6FY;EACE,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AA3Fd;AA6FY;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA3Fd;AA6Fc;EACE,yBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AA3FhB;AA8Fc;EACE,sBAAA;AA5FhB;AAgGY;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AA9Fd;AAgGc;EACE,eAAA;EACA,sBAAA;EACA,2BAAA;AA9FhB;AAgGgB;EACE,uBAAA;EACA,sBAAA;AA9FlB;AAiGc;EACE,sBAAA;AA/FhB;AAmGY;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAjGd;AAmGc;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAjGhB;AAmGgB;EACE,WAAA;EACA,YAAA;AAjGlB;AAoGgB;EACE,sBAAA;EACA,uBAAA;AAlGlB;AAoGkB;EACE,iCAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAlGpB;AAyGU;EAjKF;IAkKI,eAAA;EAtGV;EAyGY;IACE,eAAA;EAvGd;AACF;AA2GU;EACE,iCAAA;EACA,WAAA;EACA,cAAA;AAzGZ;AAgHI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AA9GN;AAiHI;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA/GN;AAmHM;EACE,mBAAA;AAjHR;AAoHM;EACE,gBAAA;AAlHR;AAqHM;EACE,2BAAA;AAnHR;AAsHM;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApHR;AAsHQ;EACE,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;AApHV;AAsHU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;AApHZ;AA0HI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AAxHN;AA2HI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAzHN;AA2HM;EACE,wBAAA;EACA,iBAAA;EACA,uBAAA;AAzHR;AA4HM;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;AA1HR;AA8HI;EACE,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;AA5HN;AA+HI;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;AA7HN;AAgII;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,uBAAA;AA9HN;AAgIM;EACE,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AA9HR;AAkII;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AAhIN;AAkIM;EACE,2DAAA;AAhIR;AAmIM;EACE,2DAAA;AAjIR;AAqII;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAnIN;AAqIM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAnIR;AAsIM;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;AApIR;AAsIQ;EACE,wBAAA;EACA,gBAAA;AApIV;AAuIQ;;EAEE,sBAAA;EACA,gBAAA;AArIV;AAwIQ;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAtIV;AAyIQ;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;AAvIV;AAyIU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;AAvIZ;AA6II;;;;;;EAME,uBAAA;AA3IN;AA8II;EAII;;;IACE,gBAAA;EA7IR;EAiJI;IACE,SAAA;EA/IN;EAiJM;IACE,eAAA;EA/IR;EAgJQ;IACE,gBAAA;IACA,gBAAA;IACA,sBAAA;EA9IV;EAgJU;IACE,aAAA;EA9IZ;EAiJU;IACE,eAAA;EA/IZ;EAqJI;IACE,SAAA;EAnJN;AACF;AAqJI;EAx1BF;IAy1BI,eAAA;EAlJJ;EAoJI;IACE,SAAA;EAlJN;EAqJI;IACE,eAAA;EAnJN;EAqJI;;;IAGE,eAAA;EAnJN;EAuJQ;IACE,gBAAA;EArJV;EAwJY;IACE,WAAA;EAtJd;EA8JM;IACE,wBAAA;EA5JR;AACF;AA+JI;EACE;;IAEE,sBAAA;IACA,SAAA;EA7JN;EA+JI;;IAEE,8BAAA;IACA,SAAA;EA7JN;EAgKI;IACE,sBAAA;IACA,SAAA;EA9JN;EAiKQ;IACE,gBAAA;IACA,mBAAA;IACA,iBAAA;IACA,wBAAA;EA/JV;EAqKM;IACE,UAAA;EAnKR;EAsKU;IACE,kBAAA;IACA,kBAAA;IACA,mBAAA;EApKZ;EAsKY;IACE,mBAAA;EApKd;EAsKc;IACE,gBAAA;EApKhB;EA2KI;IACE,sBAAA;EAzKN;EA2KM;IACE,kBAAA;IACA,uBAAA;IACA,eAAA;IACA,mBAAA;EAzKR;EA0KQ;IACE,gBAAA;EAxKV;AACF;AA8KE;EACE,WAAA;EACA,iCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA5KJ;AA8KI;EACE,WAAA;EACA,WAAA;EACA,6FAAA;AA5KN;AAoLI;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,2CAAA;EACA,cAAA;AAlLN;AAqLI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAnLN;AAqLM;EACE,YAAA;EACA,YAAA;AAnLR;AAsLM;EACE,gCAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AApLR;AAwLI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAtLN;AAwLM;EACE,gCAAA;EACA,uBAAA;EACA,gBAAA;AAtLR;AA0LI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAxLN;AA0LM;EACE,YAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;AAxLR;AA2LM;EACE,gCAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAzLR;AA2LQ;EACE,YAAA;AAzLV;AA8LI;EACE,WAAA;EACA,iBAAA;EACA,+CAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AA5LN;AA8LM;;;EAGE,gCAAA;EACA,uBAAA;AA5LR;AA+LM;EACE,+BAAA;AA7LR;AAgMM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AA9LR;AAkMI;EACE;IACE,8BAAA;EAhMN;EAmMI;IACE,iBAAA;EAjMN;AACF;AAoMI;EACE;IACE,0BAAA;EAlMN;EAqMI;IACE,sBAAA;IACA,uBAAA;EAnMN;AACF;;AAwMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArMF;AA2MA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAzMF;;AA4MA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAzMF;AA2ME;EACE,uBAAA;EACA,sBAAA;EACA,8BAAA;EACA,iBAAA;AAzMJ;AA4ME;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;AA1MJ;AA4MI;EACE,sBAAA;AA1MN;;AA+MA;EACE,gCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AA5MF;;AA8MA;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AA3MF;;AA6MA;EACE,iCAAA;EACA,iCAAA;EACA,YAAA;AA1MF;AA2ME;EACE,iCAAA;EACA,iCAAA;AAzMJ;;AA4MA;EACE,kBAAA;EACA,uBAAA;AAzMF;;AA2MA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAxMF;;AA2MA;EACE,4BAAA;AAxMF;;AA2MA;EACE,6BAAA;EACA,0BAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxMF;;AA2MA;EACE,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAxMF;AA0ME;EACE,mBAAA;EACA,sBAAA;AAxMJ;AA2ME;EACE,mBAAA;EACA,iCAAA;EACA,WAAA;AAzMJ;AA4ME;EACE,6BAAA;AA1MJ;AA6ME;EACE,iCAAA;EACA,mBAAA;AA3MJ;AA8ME;EA5BF;IA6BI,kBAAA;EA3MF;AACF;;AA8MA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,sBAAA;EACA,wBAAA;AA3MF;AA6ME;EACE,yBAAA;EACA,sBAAA;AA3MJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap');\n\n:root {\n  // blue\n  --blue-300: #5f89f8;\n  --blue-400: #395dfb;\n  --blue-500: #273cd5;\n  --blue-900: #17163d;\n\n  //grey\n  --grey-100: #f5f5f5;\n  --grey-200: #e0e0e0;\n  --grey-300: #cccccc;\n  --grey-400: #b7b7b7;\n  --grey-500: #8f8f8f;\n  --grey-600: #666666;\n  --grey-700: #363636;\n  --grey-800: #363636;\n  --grey-900: #252525;\n\n  --black-rgba: rgba(0, 0, 0, 0.8);\n\n  --fw-regular: 400;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n\n  --fs-5xl: 3.5rem; //56px\n  --fs-4xl: 3rem; //48px\n  --fs-3xl: 2rem; //32px\n  --fs-2xl: 1.5rem; //24px\n  --fs-xl: 1.25rem; //20px\n  --fs-lg: 1.125rem; //18px\n  --fs-md: 1rem; //16px\n  --fs-sm: 0.875rem; //14px\n  --fs-xs: 0.75rem; //12px\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  scroll-behavior: smooth;\n}\nhtml {\n  @media (max-width: 980px) {\n    font-size: 93.75%;\n  }\n  @media (max-width: 720px) {\n    font-size: 87.5%;\n  }\n  // @media (max-width: 480px) {\n  //   font-size: 77.5%;\n  // }\n}\nbody {\n  color: var(--grey-900);\n  background: var(--blue-900);\n  -webkit-font-smoothing: antialiased;\n}\nbody,\ninput,\ntextarea,\nbutton {\n  font-family: 'Inter', sans-serif;\n  font-weight: var(--fw-regular);\n}\nh1,\nh2,\nh3,\nh3,\nh4,\nh5,\nh6,\nstrong {\n  font-weight: 700;\n}\na {\n  color: inherit;\n  text-decoration: none;\n  transition: ease-in 0.2s;\n  &:hover {\n    transition: ease-out 0.3s;\n  }\n}\nbutton {\n  cursor: pointer;\n  padding: 12px 24px;\n  text-align: center;\n  white-space: nowrap;\n}\n[disabled] {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.app {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  background-color: var(--blue-900);\n  height: 100%;\n  width: 100%;\n  position: relative;\n\n  .header-bf {\n    position: sticky;\n    top: 0;\n    z-index: 99;\n    width: 100%;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.7) 0%,\n        rgba(0, 0, 0, 0.7) 100%\n      ),\n      #222034;\n    box-shadow: 0px 1px 4px 0px rgba(255, 213, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    padding: 16px 20px;\n    align-items: center;\n    gap: 16px;\n    flex-wrap: wrap;\n    > p {\n      text-transform: uppercase;\n      color: #fff;\n      white-space: nowrap;\n      font-weight: bold;\n      background: var(\n        --Style,\n        linear-gradient(180deg, #ffd500 0%, #c27a08 100%)\n      );\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n  }\n\n  .black-november {\n    display: flex;\n    align-items: center;\n    align-self: center;\n    padding: 6px 24px;\n    justify-content: center;\n    gap: 12px;\n    border-radius: 40px;\n    border: 1px solid #ffd500;\n    background: #000;\n    > p {\n      font-weight: bold;\n      background: var(\n        --Style,\n        linear-gradient(180deg, #ffd500 0%, #c27a08 100%)\n      );\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      text-transform: uppercase;\n    }\n  }\n\n  > header.topbar {\n    position: sticky;\n    top: 0;\n    z-index: 30;\n    background-color: var(--blue-900);\n    color: white;\n    width: 100%;\n    max-width: none;\n    display: flex;\n    justify-content: center;\n    padding: 0;\n\n    .topbar-inner {\n      width: 100%;\n      max-width: 1224px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 20px 10px;\n      gap: 24px;\n    }\n\n    .header-nav {\n      display: flex;\n      align-items: center;\n      gap: 28px;\n\n      a {\n        font-size: var(--fs-sm);\n        font-weight: var(--fw-semibold);\n        color: rgba(255, 255, 255, 0.86);\n\n        &:hover {\n          color: white;\n        }\n      }\n    }\n\n    @media (max-width: 380px) {\n      a {\n        img {\n          max-width: 200px;\n        }\n      }\n    }\n\n    .menu {\n      display: none;\n      background: transparent;\n      border: 0;\n      padding: 0;\n    }\n\n    .header-nav-mobile {\n      display: none;\n    }\n\n    .dropdown {\n      position: relative;\n    }\n\n    .header-buttons {\n      display: flex;\n      align-items: center;\n      gap: 40px;\n\n      a {\n        font-weight: var(--fw-bold);\n        display: flex;\n        align-items: center;\n        gap: 10px;\n      }\n      .ghost-link {\n        &:hover {\n          color: var(--blue-300);\n          text-decoration: underline;\n        }\n      }\n\n      .button-link {\n        background-color: var(--blue-900);\n        padding: 12px 24px;\n        border-radius: 6px;\n        border: 1px solid rgba(95, 137, 248, 0.4);\n        color: var(--blue-300);\n        white-space: nowrap;\n\n        &:hover {\n          color: white;\n          background-color: rgba(95, 137, 248, 0.4);\n        }\n      }\n    }\n\n    @media (max-width: 980px) {\n      .header-nav {\n        display: none;\n      }\n    }\n\n    @media (max-width: 580px) {\n      .menu {\n        display: inline;\n        cursor: pointer;\n        z-index: 10;\n        position: relative;\n      }\n\n      .header-buttons {\n        display: none;\n      }\n\n      .dropdown.is-open .header-buttons,\n      .dropdown:hover .header-buttons {\n        z-index: 40;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n        position: absolute;\n        top: calc(100% + 12px);\n        right: 0;\n        width: calc(100vw - 36px);\n        min-width: 0;\n        padding: 16px 20px;\n        background: #221f4e;\n        border: 1px solid rgba(95, 137, 248, 0.55);\n        border-radius: 12px;\n        box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);\n      }\n\n      .header-nav-mobile {\n        display: flex;\n        flex-direction: column;\n        gap: 14px;\n        padding-bottom: 8px;\n\n        a {\n          font-weight: var(--fw-semibold);\n        }\n      }\n    }\n  }\n\n  .sub-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 80px;\n    color: white;\n    width: 100%;\n    max-width: 1224px;\n    padding: 12px 10px 104px 10px;\n\n    .first {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      max-width: 592px;\n      .kicker {\n        color: var(--blue-300);\n        font-size: var(--fs-xs);\n        font-weight: var(--fw-bold);\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n      }\n      .title {\n        font-size: var(--fs-5xl);\n        font-weight: var(--fw-bold);\n        line-height: 1.15;\n        letter-spacing: -0.02em;\n      }\n      .text-link {\n        color: rgba(255, 255, 255, 0.86);\n        font-weight: var(--fw-semibold);\n        text-decoration: underline;\n        text-underline-offset: 4px;\n\n        &:hover {\n          color: white;\n        }\n      }\n      .subtitle {\n        width: 100%;\n        max-width: 488px;\n        font-size: var(--fs-xl);\n        font-weight: var(--fw-regular);\n        line-height: 150%;\n      }\n      a {\n        margin-top: 24px;\n      }\n    }\n\n    .second {\n      max-width: 544px;\n\n      img {\n        width: 100%;\n        max-width: 544px;\n        height: auto;\n      }\n    }\n\n    @media (max-width: 1024px) {\n      flex-direction: column;\n      align-items: center;\n\n      .first {\n        align-items: center;\n        font-size: var(--fs-3xl);\n        p {\n          text-align: center;\n        }\n      }\n    }\n\n    @media (max-width: 580px) {\n      .first {\n        align-items: center;\n      }\n    }\n  }\n\n  main {\n    width: 100%;\n    // max-width: 1440px;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    padding: 120px 0;\n    align-items: center;\n\n    .video-box {\n      width: 100%;\n      max-width: 920px;\n      overflow: hidden;\n      position: relative;\n      margin-bottom: 60px;\n      padding: 10px;\n\n      iframe {\n        border: none;\n        width: 100%;\n        aspect-ratio: 16/9;\n        border-radius: 6px;\n        box-shadow: none;\n      }\n    }\n\n    .title {\n      font-size: var(--fs-4xl);\n      font-weight: var(--fw-bold);\n      color: var(--grey-900);\n      text-align: center;\n    }\n\n    .subtitle {\n      font-size: var(--fs-xl);\n      font-weight: var(--fw-regular);\n      text-align: center;\n      strong {\n        font-weight: var(--fw-bold);\n        text-decoration: underline;\n      }\n    }\n\n    .section-header {\n      flex-direction: column;\n      display: flex;\n      gap: 16px;\n      align-items: center;\n    }\n\n    .steps {\n      display: flex;\n      gap: 40px;\n      align-items: flex-start;\n      margin-top: 58px;\n      justify-content: space-between;\n\n      img {\n        margin-top: 40px;\n        width: 100%;\n        max-width: 160px;\n      }\n\n      .card-step {\n        color: var(--grey-800);\n        font-size: var(--fs-md);\n        gap: 21px;\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n        width: 176px;\n        text-align: center;\n        line-height: 150%;\n\n        .step-number {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 80px;\n          height: 80px;\n          border-radius: 40px;\n          color: var(--blue-300);\n          background-color: rgba(57, 93, 251, 0.1);\n          font-size: var(--fs-2xl);\n          font-weight: var(--fw-semibold);\n        }\n      }\n    }\n\n    .leads,\n    .dream,\n    .feature-split {\n      max-width: 1224px;\n      padding: 0 10px;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 40px;\n\n      img {\n        width: 100%;\n        max-width: 696px;\n        height: auto;\n      }\n\n        article {\n        width: 100%;\n        max-width: 384px;\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        h1,\n        h2 {\n          font-size: var(--fs-2xl);\n          margin-top: 8px;\n          line-height: 150%;\n        }\n        p {\n          color: var(--grey-500);\n          line-height: 150%;\n        }\n\n        img {\n          width: 40px;\n          height: 40px;\n        }\n      }\n    }\n\n    .dashboard {\n      width: 100%;\n      max-width: 1118px;\n      margin-top: 120px;\n    }\n\n    .plans-features .video-box {\n      max-width: none;\n      margin: 4px 0 0;\n      padding: 0;\n    }\n\n    .end-section {\n      width: 100%;\n      border-top: 1px solid #e7eaed;\n      padding-top: 80px;\n      padding-bottom: 120px;\n      display: flex;\n      flex-direction: column;\n      gap: 120px;\n      align-items: center;\n\n      .title-animation {\n        width: 100%;\n        overflow: hidden;\n        white-space: nowrap;\n        display: flex;\n        gap: 56px;\n        text-align: center;\n\n        span {\n          animation: marquee 40s linear infinite;\n          font-weight: var(--fw-bold);\n          font-size: var(--fs-5xl);\n          background: linear-gradient(87.07deg, #273cd5 0%, #9bb7ff 100%);\n          background-clip: text;\n          -webkit-text-fill-color: transparent;\n        }\n      }\n\n      @keyframes marquee {\n        0% {\n          transform: translateX(0%);\n        }\n        100% {\n          transform: translateX(-100%);\n        }\n      }\n\n      article {\n        position: relative;\n\n        width: 100%;\n        max-width: 1216px;\n\n        .container {\n          color: white;\n          background-color: var(--blue-900);\n          display: flex;\n          gap: 40px;\n          border-radius: 24px;\n          justify-content: space-between;\n          padding-right: 80px;\n          align-items: center;\n\n          img {\n            margin-top: -46px;\n          }\n\n          div {\n            position: relative;\n            display: flex;\n            flex-direction: column;\n            gap: 18px;\n            align-items: flex-start;\n            max-width: 480px;\n            width: 100%;\n            padding-top: 45px;\n            padding-bottom: 45px;\n            padding-left: 80px;\n\n            header {\n              display: flex;\n              flex-direction: column;\n              align-items: flex-start;\n              gap: 16px;\n\n              h1 {\n                font-size: var(--fs-3xl);\n              }\n              p {\n                font-size: var(--fs-xl);\n                line-height: 150%;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .faq {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      gap: 136px;\n      width: 100%;\n      max-width: 1224px;\n      padding: 0 20px;\n\n      article {\n        width: 100%;\n        max-width: 280px;\n        gap: 16px;\n        display: flex;\n        flex-direction: column;\n        h1 {\n          font-size: var(--fs-3xl);\n          line-height: 48px;\n        }\n        p {\n          color: #4d586a;\n          line-height: 24px;\n        }\n      }\n\n      .accordion {\n        width: 100%;\n        overflow: hidden;\n\n        .accordion-header {\n          cursor: pointer;\n          padding: 1em;\n          width: 100%;\n          text-align: left;\n          border: none;\n          outline: none;\n          transition: background-color 0.2s ease;\n          font-size: var(--fs-lg);\n          font-weight: var(--fw-semibold);\n          padding: 32px 0;\n          user-select: none;\n          outline: none;\n        }\n\n        .accordion-header {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          gap: 24px;\n\n          span {\n            color: var(--blue-400);\n            font-size: var(--fs-3xl);\n            font-weight: var(--fw-regular);\n          }\n        }\n\n        .accordion-header.active {\n          background-color: white;\n        }\n\n        .accordion-header:hover {\n          background-color: white;\n        }\n\n        .accordion-content {\n          color: var(--grey-500);\n          max-height: 0;\n          overflow: hidden;\n          transition: max-height 0.2s ease-out;\n          border-bottom: 1px solid #e7eaed;\n\n          &:last-of-type {\n            border: 0;\n          }\n        }\n\n        .accordion-content.active {\n          height: auto;\n          max-height: 28em;\n          overflow-y: auto;\n        }\n\n        .accordion-content p {\n          padding-bottom: 20px;\n        }\n      }\n    }\n\n    .plans {\n      width: 100%;\n      max-width: 1224px;\n      padding: 40px 20px 80px;\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n      gap: 28px;\n\n      .plans-intro {\n        max-width: 640px;\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n\n        h2 {\n          font-size: var(--fs-4xl);\n          line-height: 1.15;\n          letter-spacing: -0.02em;\n        }\n\n        p {\n          color: var(--grey-600);\n          font-size: var(--fs-lg);\n          line-height: 1.5;\n        }\n      }\n\n      .plans-layout {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr) 380px;\n        gap: 32px 28px;\n        align-items: start;\n      }\n\n      @media (max-width: 980px) {\n        .plans-layout {\n          grid-template-columns: 1fr;\n        }\n\n        .plans-features ul {\n          grid-template-columns: 1fr;\n        }\n\n        .plans-intro h2 {\n          font-size: var(--fs-3xl);\n        }\n      }\n\n      .plans-features {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        h3 {\n          font-size: var(--fs-2xl);\n          line-height: 1.3;\n        }\n\n        ul {\n          list-style: none;\n          display: grid;\n          grid-template-columns: 1fr 1fr;\n          gap: 12px;\n        }\n\n        li {\n          display: flex;\n          gap: 12px;\n          align-items: flex-start;\n          border: 1px solid #e0e0e0;\n          border-radius: 16px;\n          padding: 16px;\n          background: white;\n\n          > span {\n            width: 36px;\n            height: 36px;\n            border-radius: 10px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            color: var(--blue-400);\n            background: rgba(57, 93, 251, 0.1);\n          }\n\n          strong {\n            display: block;\n            font-size: var(--fs-sm);\n            line-height: 1.4;\n          }\n\n          p {\n            margin-top: 4px;\n            color: var(--grey-600);\n            font-size: var(--fs-xs);\n            line-height: 1.5;\n          }\n        }\n      }\n\n      .plans-cards {\n        display: flex;\n        width: 100%;\n\n        article {\n          width: 100%;\n          min-width: 0;\n          max-width: none;\n          display: flex;\n          flex-direction: column;\n          border: 1px solid #e0e0e0;\n          border-radius: 24px;\n          padding: 40px 32px;\n          justify-content: space-between;\n          gap: 28px;\n\n          h1 {\n            display: flex;\n          }\n\n          &.recomended {\n            border: 2px solid var(--blue-300);\n            transform: scale(1.05);\n\n            .black-november {\n              display: none;\n            }\n\n            h1 {\n              align-items: center;\n              gap: 12px;\n              span {\n                padding: 6px 12px;\n                border-radius: 20px;\n                color: white;\n                font-size: 10px;\n                background-color: var(--blue-500);\n              }\n            }\n          }\n\n          &.recomended-bf {\n            background-color: #000;\n            border: 2px solid rgb(255, 196, 0);\n            transform: scale(1.05);\n\n            article,\n            header {\n              background-color: #000;\n\n              h1,\n              p {\n                color: #fff !important;\n              }\n            }\n\n            h1 {\n              align-items: center;\n              gap: 12px;\n              span {\n                padding: 6px 12px;\n                border-radius: 20px;\n                color: white;\n                font-size: 10px;\n                background-color: rgb(255, 196, 0);\n              }\n            }\n\n            a {\n              background-color: rgb(255, 196, 0);\n              color: #252525;\n              border-color: #252525;\n              font-weight: var(--fw-bold);\n              text-transform: uppercase;\n              font-size: var(--fs-sm);\n              line-height: 150%;\n            }\n          }\n\n          header {\n            display: flex;\n            flex-direction: column;\n            background-color: white;\n            gap: 16px;\n            align-items: flex-start;\n\n            h1 {\n              color: var(--blue-400);\n              font-size: var(--fs-sm);\n              text-transform: uppercase;\n              letter-spacing: 0.05em;\n              line-height: 100%;\n            }\n            > p {\n              max-width: 280px;\n              color: var(--grey-500);\n              font-size: var(--fs-sm);\n              line-height: 150%;\n\n              span {\n                background-color: #08b15c;\n                color: #f5f5f5;\n                font-size: var(--fs-xs);\n                padding: 4px 8px;\n                border-radius: 4px;\n                font-weight: var(--fw-bold);\n              }\n\n              strong {\n                color: var(--grey-300);\n              }\n            }\n\n            > div {\n              display: flex;\n              gap: 12px;\n              flex-direction: column;\n\n              .price {\n                font-size: 40px;\n                color: var(--grey-900);\n                font-weight: var(--fw-bold);\n\n                small {\n                  font-size: var(--fs-xs);\n                  color: var(--grey-400);\n                }\n              }\n              p {\n                color: var(--grey-400);\n              }\n            }\n\n            .items {\n              display: flex;\n              flex-direction: column;\n              gap: 12px;\n\n              div {\n                display: flex;\n                align-items: center;\n                gap: 12px;\n\n                img {\n                  width: 11px;\n                  height: auto;\n                }\n\n                p {\n                  color: var(--grey-500);\n                  font-size: var(--fs-sm);\n\n                  span {\n                    background-color: var(--blue-900);\n                    color: #f5f5f5;\n                    font-size: var(--fs-xs);\n                    padding: 4px 8px;\n                    border-radius: 4px;\n                    font-weight: var(--fw-bold);\n                  }\n                }\n              }\n            }\n          }\n\n          @media (max-width: 820px) {\n            min-width: 100%;\n\n            header {\n              p {\n                max-width: 100%;\n              }\n            }\n          }\n\n          .divider {\n            background-color: var(--grey-200);\n            height: 1px;\n            margin: 12px 0;\n          }\n\n        }\n      }\n    }\n\n    .block {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 40px;\n    }\n\n    .feature-wide {\n      width: calc(100% - 20px);\n      max-width: 920px;\n      height: auto;\n      border-radius: 24px;\n    }\n\n    .feature-split {\n      > img {\n        border-radius: 16px;\n      }\n\n      article {\n        max-width: 480px;\n      }\n\n      .chips {\n        justify-content: flex-start;\n      }\n\n      .feature-list {\n        list-style: none;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        li {\n          position: relative;\n          padding-left: 16px;\n          color: var(--grey-600);\n          line-height: 1.55;\n          font-size: var(--fs-sm);\n\n          &::before {\n            content: '';\n            width: 6px;\n            height: 6px;\n            border-radius: 50%;\n            background: var(--blue-400);\n            position: absolute;\n            left: 0;\n            top: 0.55em;\n          }\n        }\n      }\n    }\n\n    .product {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 120px;\n    }\n\n    .section-intro {\n      width: 100%;\n      max-width: 760px;\n      padding: 0 10px;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n      gap: 12px;\n\n      h2 {\n        font-size: var(--fs-3xl);\n        line-height: 1.25;\n        letter-spacing: -0.02em;\n      }\n\n      p {\n        color: var(--grey-600);\n        line-height: 1.6;\n        font-size: var(--fs-lg);\n      }\n    }\n\n    .kicker {\n      color: var(--blue-400);\n      font-size: var(--fs-xs);\n      font-weight: var(--fw-bold);\n      letter-spacing: 0.08em;\n      text-transform: uppercase;\n    }\n\n    .tag {\n      display: inline-flex;\n      align-items: center;\n      margin-left: 8px;\n      padding: 4px 8px;\n      border-radius: 4px;\n      background: var(--blue-900);\n      color: #f5f5f5;\n      font-size: 11px;\n      font-weight: var(--fw-bold);\n      letter-spacing: 0;\n      vertical-align: middle;\n    }\n\n    .chips {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      justify-content: center;\n\n      span {\n        border: 1px solid #e0e0e0;\n        background: #f7f8fc;\n        color: var(--grey-700);\n        border-radius: 999px;\n        padding: 6px 12px;\n        font-size: var(--fs-sm);\n        line-height: 1.4;\n      }\n    }\n\n    .card-grid {\n      width: 100%;\n      max-width: 1224px;\n      padding: 0 10px;\n      display: grid;\n      gap: 24px;\n      margin-top: 8px;\n\n      &.two {\n        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n      }\n\n      &.three {\n        grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n      }\n    }\n\n    .info-card {\n      border: 1px solid #e0e0e0;\n      border-radius: 24px;\n      overflow: hidden;\n      background: white;\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n\n      img {\n        width: 100%;\n        height: auto;\n        display: block;\n        background: #f4f6fb;\n      }\n\n      .info-body {\n        padding: 28px;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n        align-items: flex-start;\n\n        h3 {\n          font-size: var(--fs-2xl);\n          line-height: 1.3;\n        }\n\n        p,\n        li {\n          color: var(--grey-600);\n          line-height: 1.6;\n        }\n\n        ul {\n          list-style: none;\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n          margin-top: 4px;\n        }\n\n        li {\n          position: relative;\n          padding-left: 16px;\n          font-size: var(--fs-sm);\n\n          &::before {\n            content: '';\n            width: 6px;\n            height: 6px;\n            border-radius: 50%;\n            background: var(--blue-400);\n            position: absolute;\n            left: 0;\n            top: 0.55em;\n          }\n        }\n      }\n    }\n\n    #modos,\n    #temas,\n    #editor,\n    #arquivos,\n    #plans,\n    #faq {\n      scroll-margin-top: 96px;\n    }\n\n    @media (max-width: 980px) {\n      .leads,\n      .dream,\n      .feature-split {\n        img {\n          max-width: 520px;\n        }\n      }\n\n      .end-section {\n        gap: 80px;\n\n        article {\n          padding: 0 20px;\n          .container {\n            overflow: hidden;\n            padding-right: 0;\n            flex-direction: column;\n\n            img {\n              margin-top: 0;\n            }\n\n            div {\n              max-width: 100%;\n            }\n          }\n        }\n      }\n\n      .faq {\n        gap: 40px;\n      }\n    }\n    @media (max-width: 580px) {\n      padding: 64px 0;\n\n      .product {\n        gap: 72px;\n      }\n\n      .title {\n        font-size: 24px;\n      }\n      .leads,\n      .dream,\n      .feature-split {\n        padding: 0 20px;\n      }\n      .end-section {\n        article {\n          .container {\n            border-radius: 0;\n\n            div {\n              a {\n                width: 100%;\n              }\n            }\n          }\n        }\n      }\n\n      .plans {\n        h1 {\n          font-size: var(--fs-3xl);\n        }\n      }\n    }\n    @media (max-width: 780px) {\n      .dream,\n      .feature-split {\n        flex-direction: column;\n        gap: 60px;\n      }\n      .leads,\n      .feature-split.media-first {\n        flex-direction: column-reverse;\n        gap: 60px;\n      }\n\n      .steps {\n        flex-direction: column;\n        gap: 60px;\n\n        img {\n          &:first-of-type {\n            margin-top: 60px;\n            margin-bottom: 60px;\n            margin-left: 10px;\n            transform: rotate(90deg);\n          }\n        }\n      }\n\n      .end-section {\n        article {\n          padding: 0;\n\n          .container {\n            div {\n              text-align: center;\n              padding: 60px 20px;\n              align-items: center;\n\n              header {\n                align-items: center;\n\n                p {\n                  max-width: 420px;\n                }\n              }\n            }\n          }\n        }\n      }\n      .faq {\n        flex-direction: column;\n\n        article {\n          text-align: center;\n          justify-content: center;\n          max-width: 100%;\n          align-items: center;\n          p {\n            max-width: 380px;\n          }\n        }\n      }\n    }\n  }\n\n  footer {\n    width: 100%;\n    background-color: var(--blue-900);\n    color: white;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    .footer-line {\n      height: 1px;\n      width: 100%;\n      background: linear-gradient(\n        90deg,\n        var(--blue-900),\n        rgba(95, 137, 248, 0.7),\n        var(--blue-900)\n      );\n    }\n\n    .footer-main {\n      width: 100%;\n      max-width: 1224px;\n      padding: 56px 20px 40px;\n      display: grid;\n      grid-template-columns: 1.3fr repeat(4, 1fr);\n      gap: 32px 24px;\n    }\n\n    .footer-brand {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n\n      img {\n        width: 180px;\n        height: auto;\n      }\n\n      p {\n        color: rgba(255, 255, 255, 0.62);\n        font-size: var(--fs-sm);\n        line-height: 1.6;\n        max-width: 260px;\n      }\n    }\n\n    .footer-address {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      span {\n        color: rgba(255, 255, 255, 0.42);\n        font-size: var(--fs-xs);\n        line-height: 1.5;\n      }\n    }\n\n    nav {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 10px;\n\n      h2 {\n        color: white;\n        font-size: var(--fs-sm);\n        font-weight: var(--fw-semibold);\n        margin-bottom: 6px;\n      }\n\n      a {\n        color: rgba(255, 255, 255, 0.62);\n        font-size: var(--fs-sm);\n        line-height: 1.45;\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n\n        &:hover {\n          color: white;\n        }\n      }\n    }\n\n    .footer-bar {\n      width: 100%;\n      max-width: 1224px;\n      border-top: 1px solid rgba(255, 255, 255, 0.08);\n      padding: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px 24px;\n      flex-wrap: wrap;\n\n      p,\n      a,\n      span {\n        color: rgba(255, 255, 255, 0.42);\n        font-size: var(--fs-xs);\n      }\n\n      a:hover {\n        color: rgba(255, 255, 255, 0.8);\n      }\n\n      div {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: center;\n        gap: 8px 12px;\n      }\n    }\n\n    @media (max-width: 1100px) {\n      .footer-main {\n        grid-template-columns: 1fr 1fr;\n      }\n\n      .footer-brand {\n        grid-column: 1 / -1;\n      }\n    }\n\n    @media (max-width: 640px) {\n      .footer-main {\n        grid-template-columns: 1fr;\n      }\n\n      .footer-bar {\n        flex-direction: column;\n        align-items: flex-start;\n      }\n    }\n  }\n}\n\n.terms {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  p {\n    //\n  }\n}\n\n.modal-loading {\n  width: 100%;\n  max-width: 400px;\n  padding: 40px 30px;\n  color: var(--grey-600);\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.form-register {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  margin-top: 32px;\n\n  h1 {\n    font-size: var(--fs-lg);\n    color: var(--grey-700);\n    font-weight: var(--fw-regular);\n    line-height: 150%;\n  }\n\n  input {\n    padding: 12px 12px;\n    border: 2px solid var(--blue-300);\n    border-radius: 4px;\n    font-size: var(--fs-md);\n    color: var(--blue-900);\n\n    &::placeholder {\n      color: var(--grey-400);\n    }\n  }\n}\n\n.divider {\n  border-bottom: 1px solid #e7eaed;\n  margin: 120px 0;\n  width: 100%;\n  max-width: 1224px;\n}\n.btn {\n  cursor: pointer;\n  padding: 12px 24px;\n  text-align: center;\n  white-space: nowrap;\n  border-radius: 6px;\n  font-weight: var(--fw-bold);\n}\n.btn-primary {\n  border: 1px solid var(--blue-400);\n  background-color: var(--blue-400);\n  color: white;\n  &:hover {\n    border: 1px solid var(--blue-300);\n    background-color: var(--blue-300);\n  }\n}\n.btn-size-lg {\n  padding: 16px 32px;\n  font-size: var(--fs-lg);\n}\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.fullscreen-menu .ReactModal__Overlay {\n  transform: translateX(-100%);\n}\n\n.react-modal-overlay {\n  background: var(--black-rgba);\n  backdrop-filter: blur(5px);\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-modal-content {\n  background-color: var(--grey-100);\n  padding: 32px 32px;\n  position: absolute;\n  border-radius: 5px;\n  inset: 40px;\n  overflow-y: auto;\n\n  h2 {\n    padding-right: 52px;\n    color: var(--blue-400);\n  }\n\n  ::-webkit-scrollbar {\n    border-radius: 10px;\n    background-color: var(--blue-300);\n    width: 10px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background-color: var(--grey-100);\n    border-radius: 10px;\n  }\n\n  @media (max-width: 480px) {\n    padding: 30px 20px;\n  }\n}\n\n.react-modal-close {\n  position: absolute;\n  right: 5px;\n  top: 12px;\n  border: 0;\n  background: transparent;\n  font-size: 2rem;\n  color: var(--blue-300);\n  transition: ease-in 0.2s;\n\n  &:hover {\n    transition: ease-out 0.4s;\n    color: var(--blue-900);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
